<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">短信库管理</a></li>
            </ul>
        </div>    
        <div class="formbody">    
            <div class="formtitle"><span>短信库管理</span></div>    
            <ul class="forminfo">    
                <li style="padding-top:15px;">
                    <div class="forminfo_a">原始号码</div>
                    <div class="left lh33" style=" width:140px;">&nbsp;&nbsp;</div>
                    <div class="forminfo_a">
                        目标号码
                    </div>
                </li>    
                <li style="padding-top:15px;">
                    <div class="left lh33" style="width:320px;">
                        <dd class="left" style="width:100px; overflow:hidden;"> 
                            <ul class="toolbars">
                                <li class="click w66c" @click="inputMobileHD()">输入号段</li>
                                <li style="padding-left:0px;height: 33px; ">
                                    <el-upload
                                        class="upload-demo"
                                        :on-success="uploadSuccess"
                                        :action=smsToolTxtUploadUrl
                                        accept=".txt" 
                                        :show-file-list="false"
                                        :headers="uploadHeaders"
                                        :on-change="handleChange">
                                        <el-button style="margin-left: 0px;" size="small" type="primary">导入txt文件</el-button>
                                    </el-upload>
                                </li>
                                <!-- <li class="click w66c" @click="loadTxt()">导入.txt文件</li> -->
                                <li class="click w66c" @click="srcNumPX()">号码排序</li>
                                <li class="click w66c" @click="srcNumLX()">号码乱序</li>
                                <li style="padding-left:0px;height: 33px; ">
                                    <el-upload
                                        class="upload-demo"
                                        :on-success="uploadSuccess2"
                                        :action=smsToolTxtUploadUrl2
                                        :data = "fileUploadParams"
                                        accept=".txt" 
                                        :show-file-list="false"
                                        :headers="uploadHeaders"
                                        :beforeUpload="beforeAvatarUpload"
                                        :on-change="handleChange">
                                        <el-button style="margin-left: 0px;" size="small" type="primary">滤除号码</el-button>
                                    </el-upload></li>
                                <li class="click w66c" @click="srcXCCH()">消除重号</li>
                                <li class="click w66c copytag-srcnum"  @click="copySrcNum()">复制</li>
                                <li class="click w66c" @click="cleanSrcNum()">清空</li>
                            </ul>
                        </dd>
                        <dd class="left" style="width:220px; overflow:hidden;">
                            <textarea name="" cols="" readonly="readonly"  v-model="srcNum" rows="" class="textinput1" style="overflow-y:auto;"></textarea>
                        </dd>
                    </div>
    
                    <div class="left conversion" >
                        <dd class="ta_c">按号码数组</dd>
                        <dd >
                            <div class="buttonupload maringht10" @click="hmsz('up')" style="margin-left:30px;"> < </div> 
                            <div class="buttonupload maringht10" @click="hmsz('down')"> > </div>
                            </dd>
                        <dd>按组合特征</dd>
                        <dd >
                            <div class="buttonupload maringht10" @click="zhtz('up')" style="margin-left:30px;"> < </div> 
                            <div class="buttonupload maringht10" @click="zhtz('down')"> > </div>
                        </dd>
                        <dd>按号码类型</dd>
                        <dd >
                            <div class="buttonupload maringht10" @click="openHmlx('up')" style="margin-left:30px;"> < </div> 
                            <div class="buttonupload maringht10" @click="openHmlx('down')"> > </div>
                        </dd>
                        <dd>全部号码</dd>
                        <dd >
                            <div class="buttonupload maringht10" @click="moveAll('up')" style="margin-left:30px;"> < </div> 
                            <div class="buttonupload maringht10" @click="moveAll('down')"> > </div>
                        </dd>
                    </div>
                    <div class="left lh33" style="width:320px;">
                        <dd class="left" style="width:220px; overflow:hidden;">
                            <textarea name="" readonly="readonly" cols=""  v-model="descNum" rows="" class="textinput1" style="overflow-y:auto;"></textarea>
                        </dd>
                        <dd class="left" style="width:100px; overflow:hidden;"> 
                            <ul class="toolbars" style="margin-left:10px;">
                                <li style="padding-left:0px;height: 33px; ">
                                    <el-upload
                                        class="upload-demo"
                                        :on-success="uploadSuccess3"
                                        :action=smsToolTxtUploadUrl2
                                        :data = "fileUploadParams"
                                        accept=".txt" 
                                        :show-file-list="false"
                                        :headers="uploadHeaders"
                                        :beforeUpload="beforeAvatarUpload2"
                                        :on-change="handleChange">
                                        <el-button style="margin-left: 0px;" size="small" type="primary">滤除号码</el-button>
                                    </el-upload></li>
                                <li class="click w66c" @click="descNumLX()">号码乱序</li>
                                <li class="click w66c" @click="descXCCH()">消除重号</li>
                                <li class="click w66c copytag-descnum"  @click="copyDescNum()">复制</li>
                                <li class="click w66c" @click="cleanDescNum()">清空</li>
                            </ul>
                        </dd>
                    </div>
                </li>
                <li>
                    <div class="forminfo_b">当前原始号码框内有<b class="f60">{{srcNumCount}}</b> 个手机号码</div>
                    <div class="left lh33" style="width:140px;">&nbsp;&nbsp;</div>
                    <div class="forminfo_b">当前目标号码框内有<b class="f60">{{descNumCount}}</b> 个手机号码</div>
                </li>    
                <div class="xline"></div>
    
                <li style="padding-top:15px;">
                    <cite class="left"><input name="dcly" id="dcly" type="radio" value="0" checked="checked" />原始号码&nbsp;&nbsp;&nbsp;&nbsp;
                        <input name="dcly" type="radio" id="dcly" value="1" />目标号码&nbsp;&nbsp;&nbsp;&nbsp;
                    </cite>
                    <div class="buttonupload  click maringht10" @click="hddc()"> 按号码段导出 </div> 
                    <div class="buttonupload  click maringht10" @click="yysdc()"> 按运营商导出 </div>
                    <div class="buttonupload  click maringht10" @click="fpdc()"> 分批导出 </div> 
                    <div class="buttonupload  click maringht10" @click="qbdc()"> 全部导出 </div>
                </li>    
            </ul>    
            <div class="jian">&nbsp;</div>
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>注意事项及步骤</b>
            </div>    
            <ul class="infolist">
                <li><span>1、导入的文件必须是txt文件，文件里面的号码间需以空格或逗号相隔；或一行一个号码；</span></li> 
                <li><span>2、号码文件上传后可以做一些消除重号，除非手机号等操作；</span></li>
                <li><span>3、把处理好的号码全部移到右边，然后点击下面全部导出按钮把文件导出。 </span></li>
            </ul>    
        </div>     

        <!--添加号码段-->
        <div class="tip tip1">
            <div class="tiptop"><span>添加7位的号段</span><a></a></div>        
            <div class="tipinfo">
                输入7位的号段:<input name="" v-model="mobileHD" type="text" class="scinput" style="width:280px;"/>
            </div>        
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="inputHDOk()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="inputHDCancel()" value="取消" />
            </div>
        </div>
        <!-- end 添加号码段-->

        <!--号码数组-->
        <div class="tip tip2" style="height:300px;">
            <div class="tiptop"><span>按号码数值特征移动号码</span><a></a></div>        
            <div class="tipinfo" style="height:160px;">
                移动符合下列条件条件的号码：
                <br/><br/>

                1 <input name="sz1" id="sz1" type="text" size="1" class="scinput" style="width:30px;"/> <input name="sz2" id="sz2" type="text" size="1" class="scinput" style="width:30px;"/> <input name="sz3" id="sz3" type="text" size="1" class="scinput" style="width:30px;"/><input name="sz4" id="sz4" type="text" size="1" class="scinput" style="width:30px;"/><input name="sz5" id="sz5" type="text" size="1" class="scinput" style="width:30px;"/>
                  <input name="sz6" id="sz6" type="text" size="1" class="scinput" style="width:30px;"/> <input name="sz7" id="sz7" type="text" size="1" class="scinput" style="width:30px;"/> <input name="sz8" id="sz8" type="text" size="1" class="scinput" style="width:30px;"/><input name="sz9" id="sz9" type="text" size="1" class="scinput" style="width:30px;"/><input name="sz10" id="sz10" type="text" size="1" class="scinput" style="width:30px;"/>
                <br/><br/>
                注：在需要控制的位上设定号码数值，如某位不控制请保留为空。<br/>
			    如某位为空，这表示该位不作限制，可为任意值。<br/>
			    请不要每位都填入数字，这样可能没有符合条件的号码。<br/>
			    如果全部为空的话，那么可能所有号码都需要移动。
            </div>
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="moveByHmsz()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="closeHmsz()" value="取消" />
            </div>
        </div>
        <!-- end 号码数组-->

        <!--号码组合特征-->
        <div class="tip tip3" style="height:400px;">
            <div class="tiptop"><span>按号码组合特征移动号码</span><a></a></div>        
            <div class="tipinfo" style="height:260px;margin-left:20px;">
                <input name="istdszc" id="istdszc" @click="checktdszc()" type="checkbox" value=""/>包含特定数字串
                <input type="text" class="scinput" name="tdszc" id="tdszc" size="8" disabled="disabled" /><br/><br/>
                <input name="islxcd" id="islxcd" @click="checklxcd()" type="checkbox" value=""/>至少包含连续长度为
                <el-select id="lxcd" name="lxcd" v-model="lxcd" :disabled="lxcddisabled">
                    <el-option label="2" value="2"></el-option><el-option label="3" value="3"></el-option><el-option label="4" value="4"></el-option><el-option label="5" value="5"></el-option><el-option label="6" value="6"></el-option>
                    <el-option label="7" value="7"></el-option><el-option label="8" value="8"></el-option><el-option label="9" value="9"></el-option><el-option label="10" value="10"></el-option>
                </el-select><br/><br/>
                <input @click="checkmws()" name="ismws" type="checkbox" id="ismws" value="0" />至少包含多少个某位数：
			    <el-select v-model="mwsnum" :disabled="mwsnumdisabled" style="width:120px;">
				    <el-option label="2" value="2"> </el-option><el-option label="3" value="3"></el-option><el-option label="4" value="4"></el-option><el-option label="5" value="5"></el-option><el-option label="6" value="6"></el-option>
                    <el-option label="7" value="7"></el-option><el-option label="8" value="8"></el-option><el-option label="9" value="9"></el-option><el-option label="10" value="10"></el-option>
			    </el-select>&nbsp;&nbsp;<input type="text" name="mws" id="mws" size="8" class="scinput" disabled="disabled" /><br/><br/>
                <input @click="checkmwabab()" name="ismwabab" type="checkbox" id="ismwabab" value="0" />末尾四位为ABAB形式<br/><br/>
                <input @click="checkmwaabb()" name="ismwaabb" type="checkbox" id="ismwaabb" value="0" />末尾四位为AABB形式<br/><br/>
                <input @click="checkmwaaaa()" name="ismwaaaa" type="checkbox" id="ismwaaaa" value="0" />末尾四位为AAAA形式 <br/><br/>
                <input @click="checkmwabcd();" name="ismwabcd" type="checkbox" id="ismwabcd" value="0" />末尾四位为ABCD形式
            </div>
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="moveByZhtz()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="closeZhtz()" value="取消" />
            </div>
        </div>
        <!-- end 号码组合特征-->

        <!--号码类型-->
        <div class="tip tip4" style="height:300px;">
            <div class="tiptop"><span>按号码类型移动号码</span><a></a></div>        
            <div class="tipinfo" style="height:160px;">
                <input type="radio" name="hmlx" id="hmlx" value="yd" @click="checkradio()" />中国移动号码<br/><br/>
                <input type="radio" name="hmlx" id="hmlx" value="lt" @click="checkradio()"/>中国联通号码<br/><br/>
                <input type="radio" name="hmlx" id="hmlx" value="dx" @click="checkradio()" />中国电信号码<br/><br/>
                <input type="radio" name="hmlx" id="hmlx" value="zd" @click="checkradio()" />按指定范围<br/>
                1<input type="text" name="startnum" id="startnum" value="" class="scinput" size="8" disabled="disabled" />0000 --> 1<input type="text" class="scinput" name="endnum" id="endnum" value="" size="8" disabled="disabled" />9999
            </div>
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="moveByHmlx()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="closeHmlx()" value="取消" />
            </div>
        </div>
        <!-- end 号码类型-->
        <!--号码类型-->
        <div class="tip tip5" style="height:220px;">
            <div class="tiptop"><span>按照号段导出</span><a></a></div>        
            <div class="tipinfo" style="height:50px;">
                按照号码的前<input type="text" class="scinput" v-model="hdnum" size="4" />位进行导出
            </div>
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="hddcOk()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="closeHddc()" value="取消" />
            </div>
        </div>
        <!-- end 号码类型-->
    </div>
</template>
<script>
import Clipboard from 'clipboard';
import cookie from '@/components/cookie.vue';
import { openPostWindow } from '../../assets/js/winopen.js';
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            srcNum:'',
            descNum:'',
            srcNumCount:0,
            descNumCount:0,
            mobileHD:'',    //7位的手机号段
            smsToolTxtUploadUrl:this.GLOBAL.serverSrc + '/mobiletools/mobiletoolstxtupload.json',
            smsToolTxtUploadUrl2:this.GLOBAL.serverSrc + '/mobiletools/uploadmobiletoolsglhmfile.json',
            uploadHeaders:{},
            direction:'down',
            lxcd:'',
            lxcddisabled:true,
            mwsnum:'',
            mwsnumdisabled:true,
            hmlx:'',
            fileUploadParams:{},
            hdnum:"5",
        }
    },
    mounted(){

    },
    methods:{
        inputMobileHD(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
        },
        inputHDOk(){
            if(this.mobileHD.trim().length < 7){
                alert("请输入7位的号段！");
                return;
            }
            var num = "";
            var temp = "";
            for(var i=0; i<=9999; i++){
                temp = i + "";
                if( temp.length < 4){
                    for(var j=0; j<(4-(i+"").length); j++){
                        temp = "0" + temp;
                    }
                }
                temp = this.mobileHD + temp;
                if( num.length<1)
                    num = temp ;
                else
                    num = num + "\r\n" + temp;
            }
            if(this.srcNum.trim() == '')
                this.srcNum = num;
            else
                this.srcNum = this.srcNum + '\r\n';
            this.srcNumCount = this.srcNumCount + 10000;
            this.inputHDCancel();
        },
        inputHDCancel(){
            $(".tip1").fadeOut(200);
        },
        loadTxt(){

        },
        uploadSuccess(response){
            if (response.code === '0000000') {
                if(this.srcNum == null || this.srcNum.trim() == '')
                    this.srcNum = response.srcNum;
                else
                    this.srcNum = this.srcNum + "\r\n" + response.srcNum;
                this.srcNumCount = this.srcNumCount + response.srcNumCount;
            }
        },
        uploadSuccess2(response){
            this.srcNum = response.srcNum;
            this.srcNumCount = response.srcNumCount;
        },
        uploadSuccess3(response){
            this.descNum = response.descNum;
            this.descNumCount = response.descNumCount;
        },
        handleChange(){

        },
        cleanSrcNum(){
            this.srcNum = '';
            this.srcNumCount = 0;
        },
        copySrcNum(){      
            if(this.srcNum.trim() == ''){
                alert("原始号码为空！");
                return;
            }      
            var srcNum = this.srcNum;
            var clipboard = new Clipboard('.copytag-srcnum', {
                text: function() {
                    return srcNum;
                }
            });
            clipboard.on('success', e => {
                alert("复制成功！")
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                alert('该浏览器不支持自动复制!');
                // 释放内存
                clipboard.destroy()
            })
        },
        srcNumPX(){
            let that = this;
            let data = {'srcNum':this.srcNum,'type':1};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/mobiletoolshmpx.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcNum = res.data.srcNum;
                    that.srcNumCount = res.data.srcNumCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        srcNumLX(){
            let that = this;
            let data = {'srcNum':this.srcNum,'type':1};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/mobiletoolshmlx.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcNum = res.data.srcNum;
                    that.srcNumCount = res.data.srcNumCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        srcXCCH(){
            let that = this;
            let data = {'srcNum':this.srcNum,'type':1};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/mobiletoolsxcch.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcNum = res.data.srcNum;
                    that.srcNumCount = res.data.srcNumCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        hmsz(direction){
            if("down" == direction){
                if(this.srcNum.trim() == ""){
                    alert("原始号码不能为空！");
                    return;
                }
            }
            else{
                if(this.descNum.trim() == ""){
                    alert("目标号码不能为空！");
                    return;
                }
            }
            $(".tip2").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip2").fadeOut(200);
            })
            this.direction = direction;
            document.getElementById("sz1").value = '';
            document.getElementById("sz2").value = '';
            document.getElementById("sz3").value = '';
            document.getElementById("sz4").value = '';
            document.getElementById("sz5").value = '';
            document.getElementById("sz6").value = '';
            document.getElementById("sz7").value = '';
            document.getElementById("sz8").value = '';
            document.getElementById("sz9").value = '';
            document.getElementById("sz10").value = '';
        },
        closeHmsz(){
            $(".tip2").fadeOut(200);
        },
        moveByHmsz(){
            let that = this;
            let data = {'srcNum':this.srcNum,'descNum':this.descNum,'direction':this.direction,'sz1':document.getElementById("sz1").value,'sz2':document.getElementById("sz2").value,'sz3':document.getElementById("sz3").value,'sz4':document.getElementById("sz4").value,'sz5':document.getElementById("sz5").value,'sz6':document.getElementById("sz6").value,'sz7':document.getElementById("sz7").value,'sz8':document.getElementById("sz8").value,'sz9':document.getElementById("sz9").value,'sz10':document.getElementById("sz10").value};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/movebyhmsz.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcNum = res.data.srcNum;
                    that.srcNumCount = res.data.srcNumCount;
                    that.descNum = res.data.descNum;
                    that.descNumCount = res.data.descNumCount;
                    that.closeHmsz();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        zhtz(direction){
            if("down" == direction){
                if(this.srcNum.trim() == ""){
                    alert("原始号码不能为空！");
                    return;
                }
            }
            else{
                if(this.descNum.trim() == ""){
                    alert("目标号码不能为空！");
                    return;
                }
            }
            $(".tip3").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip3").fadeOut(200);
            })
            this.direction = direction;
            document.getElementById("istdszc").checked = false;
            document.getElementById("tdszc").value = "";
		    document.getElementById("tdszc").disabled = true;
            document.getElementById("istdszc").value = "0";
            this.lxcd = "";
		    this.lxcddisabled = true;
            document.getElementById("islxcd").value = "0";
            document.getElementById("islxcd").checked = false;
            document.getElementById("mws").disabled = true;
            document.getElementById("mws").value = "";
            this.mwsnum = "";
            document.getElementById("ismws").checked = false;
            document.getElementById("ismws").value = "0";
            this.mwsnumdisabled = true;
            document.getElementById("ismwaabb").checked = false;
            document.getElementById("ismwaabb").value = "0";
            document.getElementById("ismwabab").checked = false;
            document.getElementById("ismwabab").value = "0";
            document.getElementById("ismwaaaa").checked = false;
            document.getElementById("ismwaaaa").value = "0";
            document.getElementById("ismwabcd").checked = false;
            document.getElementById("ismwabcd").value = "0";
        },
        closeZhtz(){
            $(".tip3").fadeOut(200);
        },
        moveByZhtz(){
            let that = this;
            let data = {'direction':this.direction,'srcNum':this.srcNum, 'descNum':this.descNum,'istdszc':document.getElementById("istdszc").value,'tdszc':document.getElementById("tdszc").value,'islxcd':document.getElementById("islxcd").value,'lxcd':this.lxcd,'ismws':document.getElementById("ismws").value,'mwsnum':this.mwsnum,'mws':document.getElementById("mws").value,'ismwaabb':document.getElementById("ismwaabb").value,'ismwaaaa':document.getElementById("ismwaaaa").value,"ismwabcd":document.getElementById("ismwabcd").value,"ismwabab":document.getElementById("ismwabab").value};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/movebyzhtz.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcNum = res.data.srcNum;
                    that.srcNumCount = res.data.srcNumCount;
                    that.descNum = res.data.descNum;
                    that.descNumCount = res.data.descNumCount;
                    that.closeZhtz();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        checktdszc(){
            if (document.getElementById("istdszc").checked == true){
                document.getElementById("tdszc").disabled = false;
		        document.getElementById("istdszc").value = "1";
            }
            else{
                document.getElementById("tdszc").value = "";
		        document.getElementById("tdszc").disabled = true;
		        document.getElementById("istdszc").value = "0";
            }
        },
        checklxcd(){
            if (document.getElementById("islxcd").checked == true){
                this.lxcddisabled = false;
		        this.lxcd = "2";
            }
            else{
                this.lxcd = "";
		        this.lxcddisabled = true;
		        document.getElementById("islxcd").value = "0";
            }
        },
        checkmws(){
            if (document.getElementById("ismws").checked ==true ){
                document.getElementById("mws").disabled = false;
                this.mwsnum = "2";
                document.getElementById("ismws").value = "1";
                this.mwsnumdisabled = false;
            }else{
                document.getElementById("mws").disabled = true;
                this.mwsnum = "";
                document.getElementById("ismws").value = "0";
                this.mwsnumdisabled = true;
            }
        },
        checkmwabab(){
            if (document.getElementById("ismwabab").checked ==true ){
                document.getElementById("ismwabab").value = "1";
            }
            else{
                document.getElementById("ismwabab").value = "0";
            }
        },
        checkmwaabb(){
            if(document.getElementById("ismwaabb").checked ==true){
                document.getElementById("ismwaabb").value = "1";
            }else{
                document.getElementById("ismwaabb").value = "0";
            }
        },
        checkmwaaaa(){
            if(document.getElementById("ismwaaaa").checked ==true){
                document.getElementById("ismwaaaa").value = "1";
            }else{
                document.getElementById("ismwaaaa").value = "0";
            }
        },
        checkmwabcd(){
            if(document.getElementById("ismwabcd").checked ==true){
                document.getElementById("ismwabcd").value = "1";
            }else{
                document.getElementById("ismwabcd").value = "0";
            }
        },
        moveByHmlx(){
            let that = this;
            let data = {'srcNum':this.srcNum,'descNum':this.descNum,'direction':this.direction,'hmlx':this.hmlx,'startnum':document.getElementById("startnum").value,'endnum':document.getElementById("endnum").value};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/movebyhmlx.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcNum = res.data.srcNum;
                    that.srcNumCount = res.data.srcNumCount;
                    that.descNum = res.data.descNum;
                    that.descNumCount = res.data.descNumCount;
                    that.closeHmlx();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        closeHmlx(){
            $(".tip4").fadeOut(200);
        },
        openHmlx(direction){
            if("down" == direction){
                if(this.srcNum.trim() == ""){
                    alert("原始号码不能为空！");
                    return;
                }
            }
            else{
                if(this.descNum.trim() == ""){
                    alert("目标号码不能为空！");
                    return;
                }
            }
            $(".tip4").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip4").fadeOut(200);
            })
            this.direction = direction;
            this.hmlx = "";
            var checkers = document.getElementsByName('hmlx');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    checkers[i].checked = false;
                }
            }
            document.getElementById("hmlx").checked = false;
            document.getElementById("startnum").disabled = true;
            document.getElementById("startnum").value = "";
            document.getElementById("endnum").disabled = true;
            document.getElementById("endnum").value = "";
        },
        checkradio(){
            var checkers = document.getElementsByName('hmlx');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    this.hmlx = checkers[i].value;
                    if (checkers[i].value == 'zd' ){
                        document.getElementById("startnum").disabled = false;
                        document.getElementById("endnum").disabled = false;
                    }
                    else{
                        document.getElementById("startnum").disabled = true;
                        document.getElementById("endnum").disabled = true;
                    }
                }
            }
        },
        moveAll(direction){
            if("down" == direction){
                if(this.srcNum.trim() == ""){
                    alert("原始号码不能为空！");
                    return;
                }
                if(this.descNum.trim() == ''){
                    this.descNum = this.srcNum;
                }
                else{
                    this.descNum = this.descNum + "\r\n" + this.srcNum;
                }
                this.descNumCount = this.descNumCount + this.srcNumCount;
                this.srcNum = "";
                this.srcNumCount = 0;
            }
            else{
                if(this.descNum.trim() == ""){
                    alert("目标号码不能为空！");
                    return;
                }
                if(this.srcNum.trim() == ''){
                    this.srcNum = this.descNum;
                }
                else{
                    this.srcNum = this.srcNum + "\r\n" + this.descNum;
                }                
                this.srcNumCount = this.srcNumCount + this.descNumCount;
                this.descNum = "";
                this.descNumCount = 0;
            }
        },
        beforeAvatarUpload(file){
            this.fileUploadParams.mobile = this.srcNum;
            this.fileUploadParams.direction = "down";
        },
        beforeAvatarUpload2(file){
            this.fileUploadParams.mobile = this.descNum;
            this.fileUploadParams.direction = "up";
        },
        descNumLX(){
            let that = this;
            let data = {'descNum':this.descNum,'type':2};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/mobiletoolshmlx.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.descNum = res.data.descNum;
                    that.descNumCount = res.data.descNumCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        descXCCH(){
            let that = this;
            let data = {'descNum':this.descNum,'type':2};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mobiletools/mobiletoolsxcch.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.descNum = res.data.descNum;
                    that.descNumCount = res.data.descNumCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        copyDescNum(){      
            if(this.descNum.trim() == ''){
                alert("目标号码为空！");
                return;
            }      
            var descNum = this.descNum;
            var clipboard = new Clipboard('.copytag-descnum', {
                text: function() {
                    return descNum;
                }
            });
            clipboard.on('success', e => {
                alert("复制成功！")
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                alert('该浏览器不支持自动复制!');
                // 释放内存
                clipboard.destroy()
            })
        },
        cleanDescNum(){
            this.descNum = "";
            this.descNumCount = 0;
        },
        hddc(){
            //按号段导出
            var checkers = document.getElementsByName('dcly');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    if (checkers[i].value == '0' ){
                        if(this.srcNum.trim() == ''){
                            alert("原始号码不能为空！");
                            return;
                        }
                    }else{
                        if(this.descNum.trim() == ''){
                            alert("目标号码不能为空！");
                            return;
                        }
                    }
                }
            }
            $(".tip5").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip5").fadeOut(200);
            })
            this.hdnum = "5";
            $('body,html').animate({scrollTop:0},10);
        },
        closeHddc(){
            $(".tip5").fadeOut(200);
        },
        hddcOk(){
            if(this.hdnum.trim() == ''){
                alert("号段长度不能为空！");
                return;
            }
            var mobile = '';
            var checkers = document.getElementsByName('dcly');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    if (checkers[i].value == '0' ){
                        mobile = this.srcNum;
                    }else{
                        mobile = this.descNum
                    }
                }
            }
            // let that = this;
            // let data = {"srcNum":mobile,"hdnum":this.hdnum};
            // this.$ajax({
            //     method: 'post',
            //     url: this.GLOBAL.serverSrc + '/mobiletools/hddc.json',
            //     data: data,
            //     headers: {
            //         'Content-Type': 'application/json; charset=UTF-8',
            //         'token' : this.GLOBAL.token
            //     }
            // }).then(function(res) {
                
            // })
            var url = this.GLOBAL.serverSrc + '/mobiletools/hddc.json';
            var name = "xiaz";
            let list = [];
            list.push({name: "mobile", value: mobile});
            list.push({name: "hdnum", value: this.hdnum});
            openPostWindow(url, list)
        },
        yysdc(){
            //按运营商导出
            var mobile = '';
            var checkers = document.getElementsByName('dcly');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    if (checkers[i].value == '0' ){
                        if(this.srcNum.trim() == ''){
                            alert("原始号码不能为空！");
                            return;
                        }
                        else{
                            mobile = this.srcNum.trim();
                        }
                    }else{
                        if(this.descNum.trim() == ''){
                            alert("目标号码不能为空！");
                            return;
                        }
                        else{
                            mobile = this.descNum.trim();
                        }
                    }
                }
            }
            var url = this.GLOBAL.serverSrc + '/mobiletools/yysdc.json';
            var name = "xiaz";
            let list = [];
            list.push({name: "mobile", value: mobile});
            // list.push({name: "hdnum", value: this.hdnum});
            openPostWindow(url, list)
        },
        fpdc(){
            //分批导出
            var mobile = '';
            var checkers = document.getElementsByName('dcly');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    if (checkers[i].value == '0' ){
                        if(this.srcNum.trim() == ''){
                            alert("原始号码不能为空！");
                            return;
                        }
                        else{
                            mobile = this.srcNum.trim();
                        }
                    }else{
                        if(this.descNum.trim() == ''){
                            alert("目标号码不能为空！");
                            return;
                        }
                        else{
                            mobile = this.descNum.trim();
                        }
                    }
                }
            }
            var url = this.GLOBAL.serverSrc + '/mobiletools/fpdc.json';
            var name = "xiaz";
            let list = [];
            list.push({name: "mobile", value: mobile});
            // list.push({name: "hdnum", value: this.hdnum});
            openPostWindow(url, list)
        },
        qbdc(){
            //全部导出
            var mobile = '';
            var checkers = document.getElementsByName('dcly');
            for ( var i = 0; i < checkers.length; i++) {
                if (checkers[i].checked == true) {
                    if (checkers[i].value == '0' ){
                        if(this.srcNum.trim() == ''){
                            alert("原始号码不能为空！");
                            return;
                        }
                        else{
                            mobile = this.srcNum.trim();
                        }
                    }else{
                        if(this.descNum.trim() == ''){
                            alert("目标号码不能为空！");
                            return;
                        }
                        else{
                            mobile = this.descNum.trim();
                        }
                    }
                }
            }
            var url = this.GLOBAL.serverSrc + '/mobiletools/qbdc.json';
            var name = "xiaz";
            let list = [];
            list.push({name: "mobile", value: mobile});
            // list.push({name: "hdnum", value: this.hdnum});
            openPostWindow(url, list)
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smstools.vue